import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Loading from '../../components/Loading/Loading';
import images from '../../assets/images';
import { clearResponseMessage } from '../../actions/messageActions';
import { getUserProfile, updateUserProfile, logout } from '../../services/authService';
import languages from '../../data/languages';
import { DropDown } from '../../components/DropDown';
import { setUserProfile } from '../../actions/authActions';
import ProfileDropDown from '../../components/ProfileDropDown/ProfileDropDown';

//import { initWebflowReady } from '../../global/Helpers';

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.LoadData();
    this.props.clearResponseMessage();
  }

  componentWillUnmount() {
    this.props.clearResponseMessage();
  }

  LoadData = async () => {
    await this.props.getUserProfile();
    //initWebflowReady();
  };


  handlefirstNameInputChange = (e) => {
    const firstName = e.target.value;
    const { userProfile } = this.props.auth;
    if (userProfile) {
      userProfile.firstName = firstName;
    }
    this.props.setUserProfile(userProfile);
  };

  handlelastNameInputChange = (e) => {
    const lastName = e.target.value;
    const { userProfile } = this.props.auth;
    if (userProfile) {
      userProfile.lastName = lastName;
    }
    this.props.setUserProfile(userProfile);
  };

  setLanguage = (language) => {
    const { userProfile } = this.props.auth;
    if (userProfile) {
      userProfile.language = language;
    }
    this.props.setUserProfile(userProfile);
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, language } = this.props.auth;
    const profileObj = {
      firstName: firstName,
      lastName: lastName,
      language: language
    };
    const result = await this.props.updateUserProfile(profileObj);
    if (result) {
      this.LoadData();
    }
  };

  renderErrors() {
    const { resError } = this.props.message;
    if (resError) {
      return <div className='alert-message'>{resError}</div>;
    }
  }

  render() {
    const { user, loading, userProfile } = this.props.auth;
    const { firstName, lastName, language } = userProfile;
    if (loading && (!userProfile || !userProfile.firstName)) return <Loading />;

    return (
      <div className='login-body'>
        <div className='navbar pricing w-nav'>
          <div className='container w-container'>
            <div className='nav-inner-home pricing'>
              <a className='brand-logo-home w-nav-brand'>
                <img src={images['logo'].default} alt='' />
              </a>

              <ProfileDropDown
                    user={user}
                    propsParent={this.props}
              />

              <div className='menu-button w-nav-button'>
                <div className='icon w-icon-nav-menu'></div>
                <div className='top-line'></div>
                <div className='middle-line'></div>
                <div className='bottom-line'></div>
              </div>
            </div>
          </div>
        </div>
        <div className='pricing-content normal'>
          <div className='container w-container'>
            <div className='editprofile-wrapper'>
              <div className='pricing-head-block'>
                <h4 className='pricing-title'>Edit Profile</h4>
              </div>
              <div className='editprofile-block'>
                <form name='wf-form-Signup-Form' onSubmit={this.handleSubmit}>
                  <div className='form-row'>
                    <div className='form-col mb'>
                      <label htmlFor='First-Name' className='form-lable'>
                        First Name
                      </label>
                      <input
                        type='text'
                        className='form-input w-input'
                        maxLength='256'
                        name='firstName'
                        placeholder='John'
                        required=''
                        value={firstName}
                        onChange={this.handlefirstNameInputChange}
                      />
                    </div>
                    <div className='form-col mb'>
                      <label htmlFor='Last-Name' className='form-lable'>
                        Last Name
                      </label>
                      <input
                        type='text'
                        className='form-input w-input'
                        maxLength='256'
                        name='lastName'
                        placeholder='Doe'
                        required=''
                        value={lastName}
                        onChange={this.handlelastNameInputChange}
                      />
                    </div>
                    <div className='form-col mb'>
                      <label htmlFor='Last-Name' className='form-lable'>
                        Language
                      </label>
                      <DropDown
                        selectedValue={language}
                        options={languages}
                        onChange={this.setLanguage}
                      />
                    </div>
                  </div>
                  <div className='alert-box'>{this.renderErrors()}</div>
                  <div
                    className={classNames('form-btn-block', {
                      'mc-loading': loading === true
                    })}>
                    <button type='submit' className='btn-square pay w-button' disabled={loading}>
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Profile.propTypes = {
  message: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  message: state.message,
  auth: state.auth
});

export default connect(mapStateToProps, {
  clearResponseMessage,
  getUserProfile,
  setUserProfile,
  updateUserProfile,
  logout
})(Profile);
